const postImportSchedulePayload = (data) => {
  const formData = new FormData();
  formData.append('file', data);

  return formData;
};

export default postImportSchedulePayload;
